export default "__VITE_ASSET__Bqm3sJ$b__"